import formResetAttachment from '@/common/components/base/textarea/base/attachments/FormResetAttachment';
import Textarea from '@/common/components/base/textarea/base/Textarea';
import searchAttachment from '@/common/components/base/textarea/textareaInput/attachments/searchAttachment';
import { TextareaType } from '@/common/components/base/textarea/textareaInput/TextInput.type';
import { ChangeEventHandler } from 'react';
import { useController, useFormContext } from 'react-hook-form';

const TextareaInput = ({
  name,
  rules,
  label,
  placeholder,
  onChange,
  disabled,
  hasSearchAttachment = false,
  defaultValue = '',
  direction,
  placeholderAlign,
  rows,
}: TextareaType) => {
  const { control } = useFormContext();
  const controller = useController({
    rules,
    control,
    name,
    defaultValue,
  });
  const { field, fieldState } = controller;
  const errorMessage = fieldState.error?.message;
  const inputOnChange: ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    field.onChange(e.target.value);
    onChange?.(e.target.value);
  };
  const onReset = () => {
    field.onChange('');
    onChange?.('');
  };
  return (
    <Textarea
      inputProps={{
        value: field.value,
        onChange: inputOnChange,
        placeholder,
        disabled,
        rows,
      }}
      inputRef={field.ref}
      errorMessage={errorMessage}
      label={label}
      direction={direction}
      placeholderAlign={placeholderAlign}
      endAttachments={[
        formResetAttachment({
          onReset,
          renderCondition: !!field.value && !disabled,
        }),
        searchAttachment({
          shouldRender: hasSearchAttachment && (!field.value || !!disabled),
        }),
      ]}
    />
  );
};

export default TextareaInput;
